import { render, staticRenderFns } from "./LoginUtenti.vue?vue&type=template&id=35a1527f&scoped=true&"
import script from "./LoginUtenti.vue?vue&type=script&lang=js&"
export * from "./LoginUtenti.vue?vue&type=script&lang=js&"
import style0 from "./LoginUtenti.vue?vue&type=style&index=0&id=35a1527f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a1527f",
  null
  
)

export default component.exports